/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PubListConfig } from './PubListConfig';
import {
    PubListConfigFromJSON,
    PubListConfigFromJSONTyped,
    PubListConfigToJSON,
    PubListConfigToJSONTyped,
} from './PubListConfig';
import type { Share } from './Share';
import {
    ShareFromJSON,
    ShareFromJSONTyped,
    ShareToJSON,
    ShareToJSONTyped,
} from './Share';

/**
 * 
 * @export
 * @interface ConfigResponse
 */
export interface ConfigResponse  {
    /**
     * 
     * @type {string}
     * @memberof ConfigResponse
     */
    apiKey?: string;
    /**
     * 
     * @type {PubListConfig}
     * @memberof ConfigResponse
     */
    config?: PubListConfig;
    /**
     * 
     * @type {Share}
     * @memberof ConfigResponse
     */
    share?: Share;
}

/**
 * Check if a given object implements the ConfigResponse interface.
 */
export function instanceOfConfigResponse(value: object): value is ConfigResponse {
    return true;
}

export function ConfigResponseFromJSON(json: any): ConfigResponse {
    return ConfigResponseFromJSONTyped(json, false);
}

export function ConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
                  'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
                  'config': json['config'] == null ? undefined : PubListConfigFromJSON(json['config']),
                  'share': json['share'] == null ? undefined : ShareFromJSON(json['share']),
    };
}

export function ConfigResponseToJSON(json: any): ConfigResponse {
    return ConfigResponseToJSONTyped(json, false);
}

export function ConfigResponseToJSONTyped(value?: ConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'apiKey': value['apiKey'],
        'config': PubListConfigToJSON(value['config']),
        'share': ShareToJSON(value['share']),
    };
}


